import React from "react";
import { useAuth } from "./AuthContext";

const PRIMARY_BLUE = "#00a7e1";

export default function PublicHeader({
  hideWhenAuthenticated = false,
  showNav = true,
  showLoginCta = true,
  showServiceNotice = true,
  headingLevel = "h1",
}) {
  const { user } = useAuth();
  const path = typeof window !== "undefined" ? window.location.pathname : "/";
  const isActive = (p) => path === p;

  if (hideWhenAuthenticated && user) return null;

  const HeadingTag = headingLevel === "div" ? "div" : headingLevel;

  const navClass = (targetPath) =>
    `px-4 py-2 rounded-t ${
      isActive(targetPath) ? "font-semibold text-white" : "bg-gray-100 hover:opacity-90"
    }`;

  const navStyle = (targetPath) => ({
    backgroundColor: isActive(targetPath) ? PRIMARY_BLUE : "#f3f4f6",
  });

  const shouldShowLoginCta = showLoginCta && path !== "/signin" && path !== "/login";

  return (
    <header className="mx-auto mt-8 px-4">
      <div className="mx-auto w-full max-w-screen-lg mb-3 px-4">
        <div className="flex flex-col items-center">
          <a href="/" className="inline-flex items-center gap-3 pt-4 cursor-pointer select-none">
            <img
              src="/zabflow2.png"
              alt="ZabFlow AI™ Logo"
              className="w-56 h-auto"
            />
          </a>
          <HeadingTag className="mt-3 text-xl font-bold leading-tight text-center text-gray-900">
            The Intelligent Translation Workflow Platform
          </HeadingTag>
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-center text-gray-600">
            Translate complex documents with AI, preserve formatting, manage terminology, and add professional review whenever your project requires it.
          </p>
        </div>
      </div>

      {showNav && (
        <div className="mx-auto w-full max-w-screen-lg px-4 mb-2">
          <div className="flex items-center justify-between">
            <nav className="flex gap-2" aria-label="Public navigation">
              <a href="/" className={navClass("/")} style={navStyle("/")}>
                Home
              </a>
              <a href="/help" className={navClass("/help")} style={navStyle("/help")}>
                Help
              </a>
              <a href="/about" className={navClass("/about")} style={navStyle("/about")}>
                About Zab
              </a>
            </nav>

            {shouldShowLoginCta && (
              <div className="text-right">
                <span className="text-xs font-semibold text-gray-600">
                  Already have an account?
                </span>
                <div className="mt-1">
                  <a
                    href="/signin"
                    className="rounded px-3 py-1 text-sm font-semibold text-white hover:opacity-90 disabled:opacity-60"
                    style={{ backgroundColor: PRIMARY_BLUE }}
                    aria-label="Login"
                  >
                    Login
                  </a>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {showServiceNotice && (
        <div className="mx-auto w-full max-w-screen-lg mb-6 text-sm text-gray-700 leading-relaxed font-bold text-center px-4">
          For professional translation or to use the API, please contact us at{" "}
          <a
            href="mailto:request@zabtranslation.com"
            className="underline"
            style={{ color: PRIMARY_BLUE }}
          >
            request@zabtranslation.com
          </a>{" "}
          or visit{" "}
          <a
            href="https://www.zabtranslation.com"
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
            style={{ color: PRIMARY_BLUE }}
          >
            www.zabtranslation.com
          </a>
          .
        </div>
      )}
    </header>
  );
}
